import React, { useState } from "react";

import RangeList from "./rangeSlider/range-list";

import { Input, Textarea, Checkbox } from "../../../../form-inputs/inputs";
import { DEFAULT_RANGE } from "./rangeSlider/lib/constant";

const EnergyForm = (props) => {
    const [showGenerated, setShowGenerated] = useState(false);

    const toggleGenerated = (name, value) => {
        setShowGenerated(value);
    };

    const generatedStyle = showGenerated ? {} : { display: "none" };
    const panel = props.panel;

    return (
        <div>
            <div className="panel">
                <Input label="Model Number" name="modelNumber" value={panel.modelNumber} updateOnChange={props.updateField} />
                <Input label="Capacity" name="capacity" value={panel.capacity} updateOnChange={props.updateField} />
                <RangeList name="ranges" ranges={panel.ranges} updateState={props.updateField} defaultValue={DEFAULT_RANGE} />

                <fieldset className="fieldset-hider">
                    <legend>
                        <Checkbox label="Show Auto Generated by Range Slider" name="showGenerated" value={showGenerated} updateOnChange={toggleGenerated} />
                    </legend>

                    <div className="fieldset-content" style={generatedStyle}>
                        <div className="txt-warning">** Updating the Range Slider will overwrite these values! **</div>
                        <br />
                        <Input label="Estimated Yearly Cost" name="estimatedYearlyCost" value={panel.estimatedYearlyCost} updateOnChange={props.updateField} />
                        <Input label="Estimated Cost Low Range" name="estimatedCostLowRange" value={panel.estimatedCostLowRange} updateOnChange={props.updateField} />
                        <Input label="Estimated Cost High Range" name="estimatedCostHighRange" value={panel.estimatedCostHighRange} updateOnChange={props.updateField} />
                        <Input label="Estimated Cost Label" name="estimatedCostLabel" value={panel.estimatedCostLabel} updateOnChange={props.updateField} />
                        <Input label="Estimated Cost Label Range" name="estimatedCostLabelRange" value={panel.estimatedCostLabelRange} updateOnChange={props.updateField} />

                        <Input label="Estimated Energy Use Title" name="estimatedEnergyUseTitle" value={panel.estimatedEnergyUseTitle} updateOnChange={props.updateField} />
                        <Input label="Estimated Energy Use Value" name="estimatedEnergyUseValue" value={panel.estimatedEnergyUseValue} updateOnChange={props.updateField} />
                        <Input label="Estimated Energy Use UOM" name="estimatedEnergyUseUom" value={panel.estimatedEnergyUseUom} updateOnChange={props.updateField} />
                    </div>
                </fieldset>
                <Textarea label="Legal Terms" name="legalTerms" value={panel.legalTerms} updateOnChange={props.updateField} />
                <Input label="Government Website" name="governmentWebsite" value={panel.governmentWebsite} updateOnChange={props.updateField} />
                <Textarea label="Additional Product Details" name="additionalProductDetails" value={panel.additionalProductDetails} updateOnChange={props.updateField} />
                <Checkbox label="Energy Star Logo" name="hasEnergyStarLogo" value={panel.hasEnergyStarLogo} updateOnChange={props.updateField} />
            </div>
        </div>
    );
};

export default EnergyForm;
